import React from 'react';

import { CustomSVGProps } from './CustomSVGProps.types';

export function IconTicket48(props: CustomSVGProps): React.JSX.Element {
    return (
        <svg
            {...props}
            width="48"
            height="48"
            viewBox="0 0 48 48"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            aria-hidden={!props.onClick}
            aria-label="ticket">
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M0 12C0 11.4477 0.447715 11 1 11H47C47.5523 11 48 11.4477 48 12V16.0007C48 16.268 47.893 16.5241 47.7029 16.712C47.5127 16.8999 47.2553 17.0038 46.988 17.0006C46.9542 17.0002 46.9203 17 46.8864 17C42.4885 17 39 20.3993 39 24.5C39 28.6007 42.4885 32 46.8864 32C46.9203 32 46.9542 31.9998 46.988 31.9994C47.2553 31.9962 47.5127 32.1001 47.7029 32.288C47.893 32.4759 48 32.732 48 32.9993V37C48 37.2655 47.8944 37.5201 47.7066 37.7076C47.5187 37.8952 47.264 38.0004 46.9985 38L0.998515 37.9317C0.446811 37.9309 0 37.4834 0 36.9317V32.9993C0 32.4517 0.440444 32.006 0.988014 31.9994C5.33818 31.9472 8.77273 28.5692 8.77273 24.5C8.77273 20.4308 5.33818 17.0528 0.988014 17.0006C0.440444 16.994 0 16.5483 0 16.0007V12ZM2 13V15.0598C6.90287 15.5899 10.7727 19.5792 10.7727 24.5C10.7727 29.4208 6.90287 33.4101 2 33.9402V35.9332L46 35.9985V33.9622C40.9897 33.5326 37 29.4967 37 24.5C37 19.5033 40.9897 15.4674 46 15.0378V13H2Z"
                fill={props.fill || 'currentColor'}
            />
        </svg>
    );
}

export function IconTicket24(props: CustomSVGProps): React.JSX.Element {
    return (
        <svg
            {...props}
            width="24"
            height="24"
            viewBox="0 0 24 24"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            aria-hidden={!props.onClick}
            aria-label="ticket">
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M0 6C0 5.44772 0.447715 5 1 5H23C23.5523 5 24 5.44772 24 6V8.00034C24 8.26773 23.8929 8.52398 23.7027 8.71186C23.5124 8.89974 23.2548 9.00361 22.9875 9.00026L22.9457 9C21.1507 9 19.6957 10.4551 19.6957 12.25C19.6957 14.0449 21.1507 15.5 22.9457 15.5L22.9875 15.4997C23.2548 15.4964 23.5124 15.6002 23.7027 15.7881C23.8929 15.976 24 16.2323 24 16.4997V18.5C24 18.7655 23.8944 19.0201 23.7066 19.2077C23.5187 19.3952 23.2639 19.5004 22.9984 19.5L0.998448 19.4659C0.44677 19.465 0 19.0175 0 18.4659V16.4997C0 15.9523 0.440116 15.5066 0.987472 15.4997C2.76298 15.4775 4.19567 14.031 4.19567 12.25C4.19567 10.469 2.76298 9.02251 0.987472 9.00026C0.440117 8.9934 0 8.54774 0 8.00034V6ZM2 7V7.10593C4.39429 7.5941 6.19567 9.71162 6.19567 12.25C6.19567 14.7884 4.39429 16.9059 2 17.3941V17.4674L22 17.4984V17.4151C19.5519 16.9697 17.6957 14.8266 17.6957 12.25C17.6957 9.67336 19.5519 7.53026 22 7.08494V7H2Z"
                fill={props.fill || 'currentColor'}
            />
        </svg>
    );
}

export function IconTicket16(props: CustomSVGProps): React.JSX.Element {
    return (
        <svg
            {...props}
            width="16"
            height="16"
            viewBox="0 0 16 16"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            aria-hidden={!props.onClick}
            aria-label="ticket">
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M2.00003 5L2.00002 5.36018C2.99386 5.84486 3.75003 6.79437 3.75003 8C3.75003 9.20563 2.99386 10.1551 2.00002 10.6398L2.00003 11H13.9999L13.9999 10.6398C13.0061 10.1552 12.2499 9.20566 12.2499 8C12.2499 6.79434 13.0061 5.84483 13.9999 5.36015L13.9999 5H2.00003ZM4.96511e-05 4.24997C6.56847e-05 3.42058 0.728514 3 1.29171 3H14.7082C15.2714 3 15.9998 3.42056 15.9999 4.24992C15.9999 4.24995 15.9999 4.24997 15.9999 4.25L16 6.0629C16 6.53222 15.6737 6.93842 15.2154 7.03951C14.554 7.18537 14.2499 7.64419 14.2499 8C14.2499 8.35581 14.554 8.81463 15.2154 8.96049C15.6737 9.06158 16 9.46778 16 9.9371L15.9999 11.75C15.9999 11.75 15.9999 11.7501 15.9999 11.7501C15.9998 12.5794 15.2714 13 14.7082 13H1.29171C0.728513 13 6.55655e-05 12.5794 4.96511e-05 11.75C4.96511e-05 11.75 4.96511e-05 11.75 4.96511e-05 11.75L3.80947e-10 9.93703C-1.28742e-05 9.46774 0.326311 9.06157 0.784583 8.96048C1.44588 8.8146 1.75003 8.3558 1.75003 8C1.75003 7.6442 1.44588 7.1854 0.784583 7.03952C0.326311 6.93843 -1.28742e-05 6.53226 3.80947e-10 6.06297L4.96511e-05 4.25C4.96511e-05 4.24999 4.96511e-05 4.24998 4.96511e-05 4.24997Z"
                fill={props.fill || 'currentColor'}
            />
        </svg>
    );
}

export function IconTicket2_24(props: CustomSVGProps): React.JSX.Element {
    return (
        <svg
            {...props}
            width="24"
            height="24"
            viewBox="0 0 24 24"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            aria-hidden={!props.onClick}
            aria-label="ticket">
            <path
                d="M13 10C13.5523 10 14 10.4477 14 11V13C14 13.5523 13.5523 14 13 14C12.4477 14 12 13.5523 12 13V11C12 10.4477 12.4477 10 13 10Z"
                fill={props.fill || 'currentColor'}
            />
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M20 4C20.7957 4 21.5585 4.3163 22.1211 4.87891C22.6837 5.44151 23 6.20435 23 7V9C23 9.55228 22.5523 10 22 10C21.4696 10 20.961 10.2109 20.5859 10.5859C20.2109 10.961 20 11.4696 20 12L20.0098 12.1973C20.0551 12.6553 20.2577 13.0858 20.5859 13.4141C20.961 13.7891 21.4696 14 22 14C22.5523 14 23 14.4477 23 15V17C23 17.7957 22.6837 18.5585 22.1211 19.1211C21.5585 19.6837 20.7957 20 20 20H4C3.20435 20 2.44151 19.6837 1.87891 19.1211C1.3163 18.5585 1 17.7956 1 17V15C1 14.4477 1.44772 14 2 14C2.53043 14 3.03899 13.7891 3.41406 13.4141C3.78913 13.039 4 12.5304 4 12C4 11.4696 3.78913 10.961 3.41406 10.5859C3.03899 10.2109 2.53043 10 2 10C1.44772 10 1 9.55228 1 9V7C1 6.20435 1.3163 5.44152 1.87891 4.87891C2.44152 4.3163 3.20435 4 4 4H20ZM4 6C3.73478 6 3.4805 6.10543 3.29297 6.29297C3.10543 6.4805 3 6.73478 3 7V8.12793C3.68594 8.3051 4.31864 8.66239 4.82812 9.17188C5.57827 9.92202 6 10.9391 6 12C6 13.0609 5.57827 14.078 4.82812 14.8281C4.3187 15.3376 3.68585 15.6939 3 15.8711V17C3 17.2652 3.10543 17.5195 3.29297 17.707C3.48051 17.8946 3.73478 18 4 18H12V17C12 16.4477 12.4477 16 13 16C13.5523 16 14 16.4477 14 17V18H20C20.2652 18 20.5195 17.8946 20.707 17.707C20.8946 17.5195 21 17.2652 21 17V15.8711C20.3141 15.6939 19.6813 15.3376 19.1719 14.8281C18.4217 14.078 18 13.0609 18 12C18 10.9391 18.4217 9.92202 19.1719 9.17188C19.6814 8.66239 20.3141 8.3051 21 8.12793V7C21 6.73478 20.8946 6.48051 20.707 6.29297C20.5429 6.12883 20.3276 6.02757 20.0986 6.00488L20 6H14V7C14 7.55228 13.5523 8 13 8C12.4477 8 12 7.55228 12 7V6H4Z"
                fill={props.fill || 'currentColor'}
            />
        </svg>
    );
}
